// extracted by mini-css-extract-plugin
export default {"NavBarIcon":"NavBarIcon_NavBarIcon__YSyXL","NavBarIconBadged":"NavBarIcon_NavBarIconBadged__kXf9G","badgeBlue":"NavBarIcon_badgeBlue__QmSqk","badgeRed":"NavBarIcon_badgeRed__Avz0y"};